import { useEffect, useState } from "react";

const TIMES = [];
for (let h = 6; h <= 21; h += 1) ["00", "20", "40"].forEach((m) => TIMES.push(`${String(h).padStart(2, "0")}:${m}`));
const dayLabel = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("fr-CA", { weekday: "short", day: "numeric", month: "short" });

/** Flow 22 « Reporter »: a new day and time for a planned, unstarted séance. */
const MoveSessionCard = ({ api, studentId, session, mobileType = false, time, onMoved }) => {
  const [days, setDays] = useState([]);
  const [pick, setPick] = useState({ date: session.date, time: session.time });
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const size = mobileType ? "text-[15px]" : "text-[13px]";
  const field = `rounded-xl border border-gray-200 bg-white px-2 py-1.5 ${size}`;

  useEffect(() => {
    api.weekPlan(studentId).then((week) => setDays(week.days)).catch(() => setDays([session.date]));
  }, [api, studentId, session.date]);

  const move = async () => {
    setError("");
    try {
      await api.moveSession(session.id, pick);
      setDone(true);
      onMoved(pick);
    } catch (problem) {
      setError(problem.message || "Déplacement impossible.");
    }
  };

  return (
    <div className="w-[94%] sm:w-[88%] max-w-[23rem] self-start rounded-2xl rounded-tl-sm bg-white p-2.5 sm:p-3 shadow-sm" data-testid="move-session-card">
      <p className={`font-semibold text-[#122118] ${size}`}>{session.planTitle}</p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        <select className={field} disabled={done} value={pick.date} onChange={(e) => setPick((c) => ({ ...c, date: e.target.value }))} data-testid="move-session-day">
          {days.map((day) => <option key={day} value={day}>{dayLabel(day)}</option>)}
        </select>
        <select className={field} disabled={done} value={pick.time} onChange={(e) => setPick((c) => ({ ...c, time: e.target.value }))} data-testid="move-session-time">
          {TIMES.map((value) => <option key={value} value={value}>{value}</option>)}
        </select>
        {!done && <button type="button" onClick={move} className={`rounded-full bg-[#25D366] px-3 py-1.5 font-semibold text-[#0a2914] ${size}`} data-testid="move-session-save">Déplacer</button>}
      </div>
      {error && <p className="mt-2 text-xs text-[#9b3b3b]" data-testid="move-session-error">{error}</p>}
      <div className="mt-1 text-right text-[10px] text-gray-500">{time}</div>
    </div>
  );
};

export default MoveSessionCard;
